<template>
  <v-main>
    <v-toolbar dense class="grey lighten-3">
      <v-btn icon @click="reload">
        <v-icon>mdi-reload</v-icon>
      </v-btn>
      <v-spacer />
      <v-switch label="Agrupar por org" single-line hide-details />
    </v-toolbar>

    <QueueList :rows="rows" @rowClicked="showDetails" />
  </v-main>
</template>

<script>
import { Queue } from '@/models'
import QueueList from './QueueList.vue'

export default {
  components: { QueueList },
  data() {
    return {
      isLoading: false,
      rows: []
    }
  },
  mounted() {
    this.reload()
  },
  methods: {
    reload() {
      this.$loading(() => this.fetchData())
    },
    async fetchData() {
      // await this.$delay(1000)
      this.rows = await Queue.findAll({ includePaused: true })
    },
    showDetails(row) {
      this.$router.push('/mobile/queues/' + row.id)
    }
  }
}
</script>

<style></style>
